<template>
  <div class="us_app">
    <section class="user_section">
      <div class="join_wrap">
        <article class="view ac">
          <div class="title pb20" style="align-items: center">
            <h2 class="mb20">장바구니</h2>
            <p>
              <b-icon icon="check-circle-fill" color="#78420C"></b-icon>
              묶음신청은 결제창에서 가능하며, 묶음 해제는 장바구니에서 해제가
              가능합니다. <br />
              <b-icon icon="check-circle-fill" color="#78420C"></b-icon>
              약속처방은 12만원 이상 무료배송이며, 결제창에서 배송비 할인내역
              확인이 가능합니다.
            </p>
          </div>
        </article>
      </div>

      <article class="view cmnity">
        <div class="search_box gap8">
          <div class="form_inline">
            <button class="btn btn_md btn_darkbrown" @click="selectAll">
              전체 결제
            </button>
            <button
              class="btn btn_md btn_brown btn_outline" @click="buildSelectedList">
              선택 결제
            </button>
          </div>
          <div class="flex gap8">
            <div class="flex items-center gap8">
              <Datepicker v-model="searchInfo.startDate" :defaultDate="searchInfo.startDate" :format="'YYYY-MM-DD'" />
              ~
              <Datepicker v-model="searchInfo.endDate" :defaultDate="searchInfo.endDate" :format="'YYYY-MM-DD'" />
            </div>
            <div class="form_inline">
              <input
                type="text"
                class="form_control"
                placeholder="처방명/약속상품명을 입력하세요."
                v-model="searchInfo.prescribe_nm"
              />
              <button class="btn btn_md btn_darkbrown"  @click="fn_search">검색</button>
            </div>
          </div>
        </div>

        <div class="tab_contents">
          <div class="lay_left">
            <div
              class="flex gap8 mb20 items-center"
              style="justify-content: flex-end"
            >
              <b-badge variant="warning"> 묶음 </b-badge>
              <b-badge variant="dark"> 묶임 </b-badge>
              <div class="txt_info">버튼 클릭 시 묶음 취소 가능합니다.</div>
            </div>
            <div class="table_list">
              <table class="list no_view">
                <colgroup>
                  <col width="50" />
                  <col width="100" />
                  <col width="50" />
                  <col width="100" />
                  <col width="*" />
                  <col width="100" />
                  <col width="100" />
                  <col width="100" /> 
                  <col width="150" />
                  <col width="100" />
                  <col width="100" />
                </colgroup>
                <thead>
                  <tr>
                    <th></th>
                    <th>처방번호</th>
                    <th>분류</th>
                    <th>환자명</th>
                    <th>처방명</th>
                    <th>총비용</th>
                    <th>첩수</th>
                    <th>팩수</th>
                    <th>처방일자</th>
                    <th>묶음</th>
                    <th>삭제</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="checkoutList.length == 0">
                    <td colspan="11"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr
                    v-for="(item, index) in checkoutList"
                    :key="index"                    
                  >
                    <td>
                      <div class="form_checkbox" style="min-width: auto">
                        <input
                          type="checkbox"
                          :id="'checkbox' + index"
                          name="checkbox"
                          :value="item.prescribe_seq"
                          v-model="checkedSeqs"
                        />
                        <label :for="'checkbox' + index" class="jc"> </label>
                      </div>
                    </td>
                    <td>
                      <span>{{ item.prescribe_seq }}</span>
                    </td>
                    <td>
                      <span v-if="item.prescribe_type == 'T'" class="font_orange">탕전</span>
                      <span v-if="item.prescribe_type == 'I'" class="font_green">첩약</span>
                      <span v-if="item.prescribe_type == 'P'" class="font_blue">약속</span>
                    </td>
                    <td>
                      <span>{{ item.patient_nm }}</span>
                    </td>
                    <td class="ac">
                      <span>{{ item.prescribe_nm }}</span><span v-if="item.prescribe_type == 'P'">× {{item.item_quantity}} </span>
                    </td>
                    <td>
                      <span>{{ fn_comma_won(item.total_payment) }}</span>
                    </td>
                    <td>
                      <span>{{ fn_comma_won(item.prescribe_pack_cnt) }}</span>
                    </td>
                    <td>
                      <span>{{ fn_comma_won(item.packs_cnt) }}</span>
                    </td>
                    <td>
                      <span>{{ item.reg_dt }}</span>
                    </td>
                    <td>
                      <b-badge
                        v-if="item.is_combined == 'Y'"
                        class="pointer"
                        :variant="item.combined_type === 'M' ? 'warning' : 'dark'"
                        @click="fn_combine_cancel(item.combine_main_prescribe)"
                      >
                        {{ item.combined_type === "M" ? "묶음" : "묶임" }}
                      </b-badge>
                    </td>
                    <td>
                      <button class="icon icon_del" @click="fn_order_cancel(item)"></button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination :pageInfo="searchInfo.pageInfo" @clickPage="fn_movePage" v-show="pagingShow"/>
          </div>
        </div>
      </article>
    </section>
    <alert-modal 
      :id="'alert'"
      :text="showAlertMsg" 
      :btnRight="'확인'" 
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="closeEventValue"
      @closeEvent="oncCloseEvent"
      v-on:update:showSetting="fn_showSet"
    />
    <alert-modal 
          :id="'confirm'"
          :text="'주문을 취소하시겠습니까?'" 
          :btnLeft="'취소'" 
          :btnRight="'확인'" 
          :oneBtn="true"
          :isShow="comfirmAlertShow"
          :className="'btn_brown'"
          @callback="fn_alert_close"
      />
    <paymentModal :title="'결제하기'" :paymentListInfo="selectedList"
      @update-payment="fn_update_payment"/>
    <bundleModal :title="'묶음배송'" :deliveryList="selectedList" 
      @update-combine="fn_update_Combine"
      @close="fn_open_payment"/>
    <bundleCancelModal :title="'묶음배송취소'" :combinePrescribe="combineCancelPrescribe"
      @cancel-combine="fn_cancel_reserch"/>
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import Pagination from "@/components/AdminPagination.vue"
import Datepicker from "@/components/Datepicker.vue";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";
import paymentModal from "@/modal/user/paymentModal.vue";
import BundleModal from "@/modal/user/bundleModal.vue";
import BundleCancelModal from "@/modal/user/bundleCancelModal.vue";

export default {
  components: {
    Pagination,
    Datepicker,
    AlertModal,
    paymentModal,
    BundleModal,
    BundleCancelModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      searchInfo : {
        prescribe_nm : '',
        patient_nm : '',
        clinic_doctor_id : '',
        startDate : '',
        endDate : '',
        pageInfo : {
            page : 1,
            pageSize : 10,
            totPage : 0
        }                
      },
      pagingShow : false,
      checkoutList: [],

      // 체크된 prescribe_seq 목록
      checkedSeqs: [],
      // 선택된 항목만 필터링해서 담는 리스트
      selectedList: [],

      prescribe_seq : '',
      rating: 0,
      stars: Array(5).fill(null),
      secret_prescription_seq : '',
      secret_clinic_doctor_id : '',
      write_clinic_doctor_id : '',
      review_contents : '',
      combineCancelPrescribe : 0,  
      comfirmAlertShow : false,
      cancel_prescribe_seq : ''
    };
  },
    computed: {
    // 전체선택 체크 여부
    isAllChecked() {
      if (!this.checkoutList || this.checkoutList.length === 0) return false;
      return this.checkedSeqs.length === this.checkoutList.length;
    },

    //일부만 선택된 상태(상단 체크박스 indeterminate)
    isIndeterminate() {
      if (!this.checkoutList || this.checkoutList.length === 0) return false;
      return this.checkedSeqs.length > 0 && this.checkedSeqs.length < this.checkoutList.length;
    }
  },
  created(){
    
    let searchInfoStore = this.$store.getters['detailSearchInfo/getSearchInfo'];
    
    if(searchInfoStore != null && searchInfoStore != {} && searchInfoStore != ''){  
        this.searchInfo = searchInfoStore;
    }

    this.searchInfo.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
  },
  mounted(){ 
    
      //오늘 날짜구하기
      this.searchInfo.startDate =  this.getAddMonthDate(-3);
      this.searchInfo.endDate = this.getCurrentDate();

      this.fn_search();
  },
  methods : {
    fn_search(){
          console.log("@@@ search : ",this.searchInfo);

          this.$store.dispatch('detailSearchInfo/setSearchInfo', this.searchInfo); 

          axios
              .post("/api/user/mypage/getOrderCheckoutList", this.searchInfo)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.checkoutList = res.data.checkoutList;

                  this.searchInfo.pageInfo.totPage = res.data.totCnt;
                  
                  if(this.searchInfo.pageInfo.totPage> 0){
                    this.pagingShow = true;                          
                  }else{
                    this.pagingShow = false;
                  }                        

              })
              .catch((err) => console.log(err));
      },
      fn_movePage(page){
        this.searchInfo.pageInfo.page = page;
        this.fn_search();
      },
      fn_move_dtl_page(seq){
          this.$store.dispatch('detailSearchInfo/setSearchId', seq); 
          this.$router.push({ name : 'PrescriptionDetail'});
      },
      setRating(index, event) {
        const { offsetX, target } = event;
        const starWidth = target.getBoundingClientRect().width;
        const isHalf = offsetX < starWidth / 2;
        this.rating = index + (isHalf ? 0.5 : 1);
      },
      getStarIcon(index) {
        if (this.rating >= index + 1) return "star-fill";
        if (this.rating >= index + 0.5) return "star-half";
        return "star";
      },
      fn_reg_review(){

        //환자seq 정보 셋팅
        let param = new Object();
        param.prescribe_seq = this.prescribe_seq;
        param.secret_prescription_seq = this.secret_prescription_seq;
        param.secret_clinic_doctor_id = this.secret_clinic_doctor_id;
        param.write_clinic_doctor_id = this.write_clinic_doctor_id;
        param.rating = this.rating;
        param.review_contents = this.review_contents
          
        axios
            .post("/api/user/mypage/regScretPrescriptionReview", param)
            .then((res) => {
                console.log("@@@@ res : %o",res);                       
                
                let msg = "저장되었습니다.";
                this.fn_open_alert_close(msg); 
            })
            .catch((err) => console.log(err));

      },
      oncCloseEvent(){

        this.$bvModal.hide('reviewModal');
        this.fn_search();
      },
      // 전체선택
      selectAll() {
        this.checkedSeqs = this.checkoutList.map(item => item.prescribe_seq);

        this.buildSelectedList()
      },
      // 선택된 항목만으로 새 리스트 만들기
      buildSelectedList() {
        const selectedSet = new Set(this.checkedSeqs);
        this.selectedList = this.checkoutList.filter(item => selectedSet.has(item.prescribe_seq));

        this.$bvModal.show("paymentModal");
      },
      fn_update_Combine(combineProcessList){

        combineProcessList.forEach(proessItem => {
          let originItem = this.checkoutList.find(
            item => item.prescribe_seq === proessItem.prescribe_seq
          )

          if (!originItem) return

          // 필드 단위 비교
          Object.keys(proessItem).forEach(key => {

            const newVal = proessItem[key]
            const oldVal = originItem[key]

            // 1) key 자체가 없는 경우 (undefined) -> 생성 + 값 세팅
            if (typeof oldVal === 'undefined') {
              this.$set(originItem, key, newVal)
              return
            }

            // 2) key는 있는데 값이 다르면 -> 갱신
            if (newVal !== oldVal) {
              this.$set(originItem, key, newVal)
            }
          })
        })

        this.$bvModal.hide("bundleModal");

        this.buildSelectedList();
      },
      fn_open_payment(){

        this.$bvModal.show("paymentModal");
      },
      fn_combine_cancel(conbinePrescribe){

        this.combineCancelPrescribe = conbinePrescribe;

        if(this.combineCancelPrescribe != ""){
          this.$nextTick(() => {
            this.$bvModal.show('bundleCancelModal');
          });
        }
      },
      fn_cancel_reserch(){
        this.$bvModal.hide("bundleCancelModal");
        this.fn_search();
      },
      fn_update_payment(){
        this.fn_search();
      },
      fn_order_cancel(item){
        
        this.cancel_prescribe_seq = item.prescribe_seq
        this.comfirmAlertShow = true;

      },
      fn_alert_close(type){

        this.comfirmAlertShow = false;
                      
        if(type == 'ok'){

          //환자seq 정보 셋팅
          let param = new Object();
          param.prescribe_seq = this.cancel_prescribe_seq;
            
          axios
              .post("/api/user/mypage/updateOrderCancel", param)
              .then((res) => {
                  console.log("@@@@ res : %o",res);                       
                  
                  let msg = "주문을 취소하였습니다.";
                  this.fn_open_alert(msg); 

                  this.fn_search();
              })
              .catch((err) => console.log(err));
          }

      },
  }
};
</script>
